import React from "react";
import "./staffsTable.scss";
import StaffTable from "../../../components/StaffTable/StaffTable";

function StaffsTableDesktop() {
  return (
    <div className="list">
      <StaffTable />
    </div>
  );
}

export default StaffsTableDesktop;
